export const DcrConstants = {
	FH_STATUS_RED_SUBTITLE: 'These funds have major issues and need to be addressed first.',
	FH_STATUS_YELLOW_SUBTITLE: 'These funds have some changes need to be reviewed second.',
	FH_STATUS_GREEN_SUBTITLE: 'These funds are on track and have no major issues',
	FH_STATUS_RED_BUTTON_TEXT: 'Browse and Take Action',
	FH_STATUS_YELLOW_BUTTON_TEXT: 'Review Funds',
	FH_STATUS_GREEN_BUTTON_TEXT: 'View Funds',
	AOF_SUB_SECTION_TITLES: {
		statusRed: {
			title: {
				dcrKey: 'AOF_NEED_ATTENTION_SECTION_TITLE',
				dcrValue: 'Need Immediate Attention'
			},
			subtitle: {
				dcrKey: 'AOF_NEED_ATTENTION_SECTION_SUB_TITLE',
				dcrValue: 'Select an individual CTA to view all the funds that have been flagged in that category.'
			}
		},
		statusYellow: {
			title: {
				dcrKey: 'AOF_NEED_REVIEW_SECTION_TITLE',
				dcrValue: 'Need Review'
			},
			subtitle: {
				dcrKey: 'AOF_NEED_REVIEW_SECTION_SUB_TITLE',
				dcrValue: 'Select an individual CTA to view all the funds that have been flagged in that category.'
			}
		}
	}
};
